import { inject, observer } from 'mobx-react'
import React from 'react'
import workAreaStore from '../../store/workAreaStore'
import SidebarSlide from './SidebarSlide'
import { ReactComponent as CheckRight } from '../../svg/chevron-right.svg'
import TextStyleSlide from './Slides/TextStyleSlide'

@inject('templateStore', 'store', 'errorStore', 'saveStore', 'layerStore', 'sidebarStore', 'workAreaStore') @observer
class Sidebar extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      windowWidth: 0
    }
  }

  async componentDidMount(){
    window.addEventListener('resize', this.setWidth.bind(this))
  }

  setWidth(e){
    const { target } = e
    this.setState({
      windowWidth: target.outerWidth
    })
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.setWidth.bind(this))
  }

  changeActiveItem(id){
    const { sidebarStore, workAreaStore, store } = this.props
    const activeItem = sidebarStore.getActiveSlide()
    if(sidebarStore.fullScreen){
      this.toggleFull()
    }
    if(activeItem && activeItem.id === id){
      sidebarStore.closeSidebarSlide()
      return
    }
    if(workAreaStore.editingTextId){
      sidebarStore.closeSidebarSlide()
      workAreaStore.deselectSelectedLayer()
    }
    if(!store.auth && id === 'uploads'){
      store.toggleUpgradeModal('register', true)
    }else{
      sidebarStore.changeStatus(id)
      this.props.templateStore.togglePublicTemplatesColumn(null, false)
      const active = workAreaStore.getSelectedLayer()
      workAreaStore.setHidden(false)
    }
  }  
  
  getActiveSlide(){
    return this.props.sidebarStore.items.find(({ active }) => active)
  }

  toggleFull(){
    if(this.props.sidebarStore.fullScreen){
      this.props.workAreaStore.setHidden(false)
    }else{
      this.props.workAreaStore.setHidden(true)
    }
    this.props.sidebarStore.toggleFullscreen()
    setTimeout(() => {
      this.props.workAreaStore.setPageCenter(false, true)
    }, 0)
  }

  checkAndCloseCropper(e){
    const nodeName = e.target.nodeName
    if(nodeName && typeof(nodeName) === 'string' && nodeName.toLowerCase() !== 'svg'){
      this.props.workAreaStore.checkAndCloseCropper()
    }
  }

  async openNFTModal(){
    await this.props.saveStore.saveDesign(true)
    if(this.props.workAreaStore.emptySaved){
      this.props.errorStore.setErrorMessage(`Cannot create NFT from an empty design`, true)
    }
    const layers = this.props.workAreaStore.getAllLayers()
    const isGif = !!layers.find(l => {
      const { photoType } = l
      const t = photoType ? photoType.toLowerCase() : null
      return t === 'gif' || t === 'sticker'
    })
    if(isGif){
      this.props.errorStore.setErrorMessage(`Cannot make a NFT ouf of a GIF`, false)
      return
    }
    if(this.props.workAreaStore.compiled && !this.props.workAreaStore.emptySaved){
      this.props.store.toggleAnyModal('nftOpen', true)
    }
  }

  /*
  getNFTItem(){
    if(this.props.store.auth && !this.props.workAreaStore.mockupBase && this.props.store.nft && this.props.store.nft.enabled){
      return (
        <div className='sidebar-item' onClick={() => this.openNFTModal()}>
          <div className='sidebar-item__icon nft'>
            <img className='nft-icon' src='/design-editor/nft-wallet.gif' />
          </div>
          <div className='sidebar-item__meta'>
            <span className='sidebar-item__title'>
              Mint NFT
            </span>
          </div>
        </div>
      )
    }else{
      return <div />
    }
  }
  */

  render () {
    const { items: sidebarItemList, open, fullScreen, textStyleOpen, activeItem } = this.props.sidebarStore
    const { workAreaStore } = this.props
    let items = [...sidebarItemList]
    if(workAreaStore.mockupBase){
      items = items.filter(item => item.id !== 'templates')
    }
    let className = fullScreen ? `sidebar full-screen ${open ? 'open' : ''}` : `sidebar ${open || textStyleOpen ? 'open' : ''}`
    const item = this.getActiveSlide()
    const show = item ? item.id === 'photos' || item.id === 'illustrations' || item.id === 'gifs' || item.id === 'uploads' || item.id === 'templates' : false
    if(item && item.id && !className.includes(item.id)){
      className += ` ${item.id}`
    }
    return (
      <div 
        className={className} 
        onClick={e => {
          this.checkAndCloseCropper(e)
          workAreaStore.toggleAlign(false)
          workAreaStore.toggleShift(false)
          this.props.store.toggleAnyModal('none', false)
        }}
      >
        <div className='sidebar-menu-wrapper'>
          <div className='sidebar-menu'>
            {
              items.filter(f => f.showInList)
                .map(item => (
                <div 
                  onClick={() => this.changeActiveItem(item.id)} 
                  className={item.active ? 'sidebar-item active' : 'sidebar-item'} 
                  key={item.id}
                >
                  <div className='sidebar-item__icon'>
                    {item.icon}
                  </div>
                  <div className='sidebar-item__meta'>
                    <span className='sidebar-item__title'>{item.title}</span>
                  </div>
                </div>
              ))
            }
            {/* this.getNFTItem() */}
          </div>
        </div>
        {
          open ?
          <SidebarSlide {...this.state} {...this.props} />
          :
          <div className='sidebar-slide-closed'/>
        }{
          workAreaStore.textStyleToolbars.map(toolbar => (
              <TextStyleSlide
                shadowStatus={workAreaStore.textShadowUpdate}
                activeItem={activeItem}
                textId={toolbar.id}
                lastColor={workAreaStore.lastTextColor}
                selectedText={workAreaStore.editingTextId}
                key={toolbar.id}
                {...toolbar}
              />
            ))
        }
        {
          !show ? undefined : 
          (
            <div className='sidebar__toggle' style={{right: fullScreen ? '-5px' : '-20px', transform: fullScreen ? 'rotate(180deg)' : ''}} onClick={this.toggleFull.bind(this)}>
              {
                <CheckRight />
              }
            </div>
          )
        }
      </div>
    )
  }
}

export default Sidebar
